import QdtComponents from "qdt-components";

const options = {
  config: {
    host: "qap.ipc-global.com",
    // appId: "e72b19a6-40ea-4b5e-b0fe-98db3cb6be91", //2024
    appId: "4416806b-0b28-4dd0-a781-de3f39810e15", //2025
    secure: true,
    port: 443,
    prefix: "",
  },
  connections: {
    vizApi: true,
    engineApi: true,
  },
};

const qdtComponents = new QdtComponents(options.config, options.connections);

export { qdtComponents, options };
